
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import MissionVisionQuality from './components/MissionVisionQuality';
import ProductCarousel from './components/ProductCarousel';
import Testimonials from './components/Testimonials';
import Membership from './components/Membership';
import ContactForm from './components/ContactForm';
import VideoCarousel from './components/VideoCarousel';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import Header from './components/Header';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header isScrolled={isScrolled} />
      <Hero />
      <About />
      <MissionVisionQuality />
      <ProductCarousel />
      <Testimonials />
      <Membership />
      <ContactForm />
      <VideoCarousel />
      <Gallery />
      <Footer />
      
      {/* WhatsApp Chatbot */}
      <a
        href="https://wa.me/1234567890"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="Chat on WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>
    </div>
  );
}
